import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import InteractionGuard from '../components/guards/InteractionGuard';
import { apiClient, ApiError } from '../services/api';

export default function Image() {
  const { isAuthenticated } = useAuth();
  const [prompt, setPrompt] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [result, setResult] = useState<{ image_url?: string; job_id?: string } | null>(null);
  const [showGuard, setShowGuard] = useState(false);

  const handleGenerate = async () => {
    if (!isAuthenticated) {
      setShowGuard(true);
      return;
    }

    if (!prompt.trim()) {
      return;
    }


    try {
      setLoading(true);
      setError(null);
      const response = await apiClient.createImage({
        prompt: prompt.trim(),
        model: 'default',
      });
      setResult(response);
    } catch (err) {
      setError(
        err instanceof ApiError ? err.message : 'Failed to generate image'
      );
    } finally {
      setLoading(false);
    }
  };

  if (showGuard) {
    return (
      <InteractionGuard
        onAuthenticated={() => {
          setShowGuard(false);
          handleGenerate();
        }}
        onCancel={() => setShowGuard(false)}
        actionName="generate images"
      />
    );
  }

  return (
    <div className="min-h-full flex flex-col items-center justify-center py-12">
      <div className="fluid-container w-full">
        <h1 className="fluid-h2 font-bold text-white mb-6">Generate Image</h1>
        
        <div className="bg-white/5 border border-white/20 rounded-xl p-6 mb-6">
          <label className="block text-white mb-2">Prompt</label>
          <textarea
            value={prompt}
            onChange={(e) => setPrompt(e.target.value)}
            placeholder="Describe the image you want to generate..."
            className="w-full bg-black/50 border border-white/20 rounded-lg p-4 text-white placeholder-white/50 focus:outline-none focus:ring-2 focus:ring-white/50"
            rows={6}
          />
        </div>

        <button
          onClick={handleGenerate}
          disabled={loading || !prompt.trim()}
          className="w-full bg-white text-black py-3 rounded-lg font-semibold hover:bg-gray-200 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {loading ? 'Generating...' : 'Generate Image'}
        </button>

        {error && (
          <div className="mt-4 p-4 bg-red-500/20 border border-red-500/50 rounded-lg text-red-400">
            {error}
          </div>
        )}

        {result && (
          <div className="mt-4">
            {result.image_url ? (
              <div className="bg-white/5 border border-white/20 rounded-xl p-4">
                <img
                  src={result.image_url}
                  alt="Generated"
                  className="w-full rounded-lg"
                />
              </div>
            ) : (
              <div className="p-4 bg-green-500/20 border border-green-500/50 rounded-lg text-green-400">
                Image generation started! Job ID: {result.job_id}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

